export enum DictationStatus {
  DictationIdle,
  DictationStarting,
  DictationStarted,
}
